import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

/* ---------------------------------------
Categories
--------------------------------------- */

// Handle retrieve categories
export const handleRetrieveForumCategories = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        headers: headers(),

        method: "GET",
        url: `${BASEURI}/public/forum/category/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

/* ---------------------------------------
Reaction
--------------------------------------- */

// Handle add forum reaction
export const addForumtReaction = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        data: data?.formData || {},
        url: `${BASEURI}/user/forum/react/${data?.id}`,
      },
      thunkAPI
    )
  }
)

/* ---------------------------------------
Forum
--------------------------------------- */

// Handle retrieve all forums
export const handleRetrieveForums = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
      categoryId: data?.categoryId || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/public/forum/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve single forum
export const handleRetrieveSingleForum = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/public/forum/retrieve/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)
export const handleRetrievePopularForums = createAsyncThunk(
  "retrievePopular",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/public/forum/retrieve-popular`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)